import { getValueByKeyV2 } from "@/03-presenters/shared/helper";
import { searchEntityV3 } from "@/04-drivers/dal/entities";
import { respCodeCheck } from "@/04-drivers/dal/error";
import {
  InspirationKeywordExtension,
  InspirationOutput,
  InspirationSearchEvent,
} from "./interface";

export async function getInspirationVideoCardList(reqBody: any) {
  const res = await searchEntityV3(
    reqBody,
    "",
    "entity/tiktok/material/search/list",
  );
  const entityList = res.entity_list;
  const videoCardList = entityList.map((entity) => {
    return {
      entityID: entity.entity_id,
      videoCover: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_cover",
      ),
      videoDesc: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_desc",
      ),
      videoDurationForSearch: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_duration",
      ),
      videoAuthorAvatar: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_user_avatar",
      ),
      videoAuthorNickname: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_author_unique_id",
      ),
      videoPlayCount: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_play_count",
      ),
      shareUrl: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_share_url",
      ),
      videoLikeCount: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_like_count",
      ),
      videoCreatorFollowerCnt: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_follower_count",
      ),
      videoShareCount: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_share_count",
      ),
      videoCommentCount: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_comment_count",
      ),
      video30dGmv: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_video_total_gmv",
      ),
      videoLaunchTime: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_create_time",
      ),
      videoAdSource: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_ad_source",
      ),
      productImages: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_product_images",
      ),
      s3Url: getValueByKeyV2(entity, "tiktok_material_search_material_os"),
      countryCode: getValueByKeyV2(
        entity,
        "tiktok_material_search_material_country_code",
      ),
    };
  });
  return videoCardList;
}

export async function submitInspirationSearch(reqBoby: any) {
  const res = await fetch(
    "/api/v3/additional/service/workflow/video/material/cluster/submit",
    {
      method: "POST",
      body: JSON.stringify(reqBoby),
      headers: {
        "content-type": "application/json",
      },
    },
  );
  const data = await res.json();
  respCodeCheck(data?.base_resp);
  return data?.task_id as string;
}

export async function fetchInspirationSearchStatus(taskId: string) {
  const res = await fetch(
    "/api/v3/additional/service/workflow/video/material/cluster/event",
    {
      method: "POST",
      body: JSON.stringify({ task_id: taskId }),
      headers: {
        "content-type": "application/json",
      },
    },
  );
  const data = await res.json();
  respCodeCheck(data?.base_resp);
  return data?.data as InspirationSearchEvent;
}

export async function getInspirationOutput(taskId: string) {
  const res = await fetch(
    "/api/v3/additional/service/workflow/video/material/cluster/output",
    {
      method: "POST",
      body: JSON.stringify({ task_id: taskId }),
      headers: {
        "content-type": "application/json",
      },
    },
  );
  const data = await res.json();
  respCodeCheck(data?.base_resp);
  return data?.data as InspirationOutput;
}
export async function getInspirationKeywordList(keyword: string) {
  const res = await fetch(
    "/api/v3/additional/service/video/material/cluster/keyword_extension",
    {
      method: "POST",
      body: JSON.stringify({ keyword }),
      headers: {
        "content-type": "application/json",
      },
    },
  );
  const data = await res.json();
  respCodeCheck(data?.base_resp);
  return data as InspirationKeywordExtension;
}
